import { unmaskPhone, unmaskPostalCode } from '../../u2000Core/tools/U2000MaskUtils';
import { NS } from '../U3120Constants';
import type { U3120Customer } from '../U3120Service';

export type U3120Translate = (key: string, options?: { ns?: string }) => string;

const ns = { ns: NS };

export function u3120ValidateCustomer(customer: U3120Customer, t: U3120Translate): Record<string, string> {
  const result: Record<string, string> = {};
  if (!customer.customerCode || customer.customerCode.trim() === '') {
    result.customerCode = t('errCustomerCodeRequired', ns);
  }
  if (customer.customerCode && customer.customerCode.length > 10) {
    result.customerCode = t('errCustomerCodeMaxLength', ns);
  }
  if (!customer.customerName || customer.customerName.trim() === '') {
    result.customerName = t('errCustomerNameRequired', ns);
  }
  if (customer.customerName && customer.customerName.length > 100) {
    result.customerName = t('errCustomerNameMaxLength', ns);
  }
  const ct = customer.customerType;
  if (!ct || (typeof ct === 'string' && !ct.trim()) || (typeof ct === 'object' && (!ct.id || !ct.id.trim()))) {
    result['customerType.id'] = t('errCustomerTypeRequired', ns);
  }
  if (customer.address && customer.address.length > 100) {
    result.address = t('errAddressMaxLength', ns);
  }
  if (customer.city && customer.city.length > 75) {
    result.city = t('errCityMaxLength', ns);
  }
  if (!customer.language || customer.language.trim() === '') {
    result.language = t('errLanguageRequired', ns);
  }
  if (customer.postalCode && unmaskPostalCode(customer.postalCode).length !== 6) {
    result.postalCode = t('errPostalCodeInvalid', ns);
  }
  if (customer.officePhone1 && unmaskPhone(customer.officePhone1).length !== 10) {
    result.officePhone1 = t('errPhoneNumberInvalid', ns);
  }
  if (customer.officePhone2 && unmaskPhone(customer.officePhone2).length !== 10) {
    result.officePhone2 = t('errPhoneNumberInvalid', ns);
  }
  if (!customer.country || !customer.country.id || customer.country.id === '') {
    result['country.id'] = t('errCountryRequired', ns);
  }
  if (!customer.state || !customer.state.id || customer.state.id === '') {
    result['state.id'] = t('errStateRequired', ns);
  }
  return result;
}
